import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import OwnerChangeDialogView from "./OwnerChangeDialogView";
import { updateCompanyOwnerApi } from "services/CompanyService";

const OwnerChangeDialog = ({ nonOwnerCompanyManagers, company, usersMutate }) => {
	const [selectedOwnerId, setSelectedOwnerId] = useState(null);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [show, setShow] = useState(false);
	const [errors, setErrors] = useState({});

	useEffect(()=>{
		if(nonOwnerCompanyManagers.length === 0){
			setErrors({ owner_id: "There is no Company Manager available to transfer the role to." })
		}
	},[nonOwnerCompanyManagers])

	const handleCompanyOwnerSelectChange = (e) => {
		setSelectedOwnerId(e.target.value);
	};

	const handleChangeOwnerSubmit = async () => {
		setIsSubmitting(true);

		if (!selectedOwnerId) {
			setErrors({ owner_id: "Please select a company manager." });
			setIsSubmitting(false);
			return;
		}

		try {
			await updateCompanyOwnerApi(company?.id, { owner_id: selectedOwnerId, company_id: company?.id });
			toast.success("Company owner updated successfully.");
			handleClose();
			usersMutate();

			setErrors({}); // Clear errors on success to avoid displaying stale error messages
		} catch (error) {
			toast.error(error.response?.data?.message || "Failed to update company owner.");
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleShow = () => {
		setShow(true);
	}

	const handleClose = () => {
		setShow(false);
	}

	return (
		<OwnerChangeDialogView
			show={show}
			handleClose={handleClose}
			companyManagers={nonOwnerCompanyManagers}
			handleCompanyOwnerSelectChange={handleCompanyOwnerSelectChange}
			handleChangeOwnerSubmit={handleChangeOwnerSubmit}
			errors={errors}
			isSubmitting={isSubmitting}
			handleShow={handleShow}
		/>
	);
};

export default OwnerChangeDialog;
